// @flow
import NiubizWebPayment from './NiubizWeb';
import PaypalPayment from './Paypal';
import SafetyPayPayment from './SafetyPay';
import BitpayPayment from './Bitpay';
import CulqiPayment from './Culqi';
import BlueSnapPayment from './BlueSnap';
import KashioPayment from './Kashio';
import Payme from './Payme';

import type { Order } from '../../../../entities';
import type { Node } from 'react';
import type { BillingAddressReq } from '../api';
import type { RootState } from '../../../index';

export type ImplementationType = 'paypal' | 'safetypay' | 'bitpay' | 'amazonpay' | 'authorize_net' | 'culqi'
  | 'bluesnap' | 'kashio' | 'payme_usd' | 'niubiz_decoupled' | 'niubiz_web';

export interface PaymentImpl {
  // generateTokenURL?: string;
  type: ImplementationType;

  // Setup internal implementation of each type.
  // Here we can save order, dispatch or country as instance properties like SafetyPay
  // or define all functions as instance properties using order, dispatch, country or locale and
  // later on, be used on `generateCustomUI` like Paypal.
  setUpPayment(order: Order, dispatch: Function, rootState: RootState): void;

  // This function is used when the payment provider
  // such as paypal or stripe, provides it's own ui button implementation
  generateCustomUI(): ?Node;

  // This function is used when the payment provider
  // does not provide a ui button, however you need to call a function
  // in order to start the payment popup (such as Bitpay) or mechanism
  // (such us Safetypay). We provide billingAddress if custom logic needs it.
  executeUIAction(billingAddress: BillingAddressReq, rootState: RootState): void;

  // This function is optional. It is meant to be used in stand-alone way
  // by order package, when a payment has been issued but it is not confirmed yet,
  // in case the end-user want to see the payment "popup" again like SafetyPay or
  // Bitpay.
  showPopUp(data: string): void;

  // This is to clean up all the generated ui
  clean(): void;
}

// Default BlueSnap
export function getImplementation(paymentImpl: string): ?PaymentImpl {
  const lower = paymentImpl.toLowerCase();
  switch (lower) {
    // case 'niubiz_decoupled':
    //   return new NiubizPayment();
    case 'niubiz_web':
      return new NiubizWebPayment();
    case 'paypal':
      return new PaypalPayment();
    case 'safetypay':
      return new SafetyPayPayment();
    case 'bitpay':
      return new BitpayPayment();
    // case 'amazon':
    //   return new AmazonPayPayment();
    // case 'authorize_net':
    //   return new AuthorizePayment();
    case 'culqi':
      return new CulqiPayment();
    case 'kashio':
      return new KashioPayment();
    case 'bluesnap':
      return new BlueSnapPayment();
    case 'payme_usd':
      return new Payme();
    default:
      // return new BlueSnapPayment();
      // throw new Error("Payment implementation not found");
      return undefined;
  }
}






// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/PaymentImpl/index.js